export class AssetTransferAdd {
    assetOldIds: number[];
    assetNewIds: number[];
    employeeId: number;
    invStateId: number;
}
